module.exports = "<language-select class=header-language :value=currentLanguageCode @change=handleLocaleChanged></language-select>";